import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { setNavigator } from 'utils/navigation';
import woothee from 'woothee';

// dynamic import
const SurveyGate = React.lazy(() =>
  import(/* webpackChunkName: "SurveyGate" */ 'features/SurveyGate').then((m) => ({
    default: m.SurveyGate,
  })),
);
const Backend = React.lazy(() => import(/* webpackChunkName: "Backend" */ 'containers/Backend'));
const Completed = React.lazy(
  () => import(/* webpackChunkName: "Completed" */ 'components/common/Completed'),
);
const Closed = React.lazy(
  () => import(/* webpackChunkName: "Closed" */ 'components/common/Closed'),
);
const BaseNotFound = React.lazy(
  () => import(/* webpackChunkName: "BaseNotFound" */ 'components/common/NotFound'),
);
const SurveyError = React.lazy(() =>
  import(/* webpackChunkName: "SurveyError" */ 'features/SurveyError').then((m) => ({
    default: m.SurveyError,
  })),
);

type Props = {
  isInitializedXCSRFToken: boolean;
  onRequestFetchXCSRFToken: () => void;
  setDeviceVariant: (userDevice: string) => void;
};

const App = (props: Props) => {
  const { isInitializedXCSRFToken, onRequestFetchXCSRFToken, setDeviceVariant } = props;
  const userAgent = woothee.parse(window.navigator.userAgent);
  const userDevice = userAgent.category;
  const navigate = useNavigate();

  // saga など React ツリー外から navigate を呼べるように登録する
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  useEffect(() => {
    onRequestFetchXCSRFToken();
    setDeviceVariant(userDevice);
  }, []);

  if (!isInitializedXCSRFToken) return null;

  return (
    <Suspense fallback={null}>
      <Routes>
        {/* survey_uuid 不明の OAuth エラー用。v7 は静的セグメントを優先するため /surveys/:id より先にマッチする。 */}
        <Route path='/surveys/error' element={<SurveyError />} />
        <Route path='/surveys/:id' element={<SurveyGate />} />
        <Route path='/admin/*' element={<Backend />} />
        <Route path='/backyard/*' element={<Backend />} />
        <Route path='/' element={<Navigate to='/admin/sign_in' replace />} />
        <Route path='/completed' element={<Completed />} />
        <Route path='/closed' element={<Closed />} />
        <Route path='*' element={<BaseNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default App;
